import React from "react";
import {
  Button,
  Grid,
  Paper,
  TextField,
  makeStyles,
} from "@material-ui/core";
import Title from "./Title";
import FilterListIcon from "@material-ui/icons/FilterList";
import { i18n } from "../../translate/i18n";
import { getStandardButtonStyles } from "../../styles/standardButtons";

const useStyles = makeStyles((theme) => ({
  ...getStandardButtonStyles(theme),
  filterButton: {
    height: 38,
    marginTop: 12,
  }
}));

const Filters = ({
  classes: parentClasses,
  setDateStartTicket,
  setDateEndTicket,
  dateStartTicket,
  dateEndTicket,
  setQueueTicket,
  queueTicket,
  fetchData,
}) => {
  const localClasses = useStyles();
  const [queues] = React.useState(queueTicket);
  const [dateStart, setDateStart] = React.useState(dateStartTicket);
  const [dateEnd, setDateEnd] = React.useState(dateEndTicket);
  const [fetchDataFilter, setFetchDataFilter] = React.useState(false);

  return (
    <Grid item xs={12}>
      <Paper className={parentClasses?.customFixedHeightPaperLg} variant="outlined">
        <Title>{i18n.t("dashboard.filters.title")}</Title>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} sm={6} md={5}>
            <TextField
              fullWidth
              name="dateStart"
              label={i18n.t("dashboard.date.initialDate")}
              InputLabelProps={{
                shrink: true,
              }}
              type="date"
              defaultValue={dateStart}
              onChange={(e) => setDateStart(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={5}>
            <TextField
              fullWidth
              name="dateEnd"
              label={i18n.t("dashboard.date.finalDate")}
              InputLabelProps={{
                shrink: true,
              }}
              type="date"
              defaultValue={dateEnd}
              onChange={(e) => setDateEnd(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Button
              fullWidth
              size="small"
              variant="outlined"
              className={`${localClasses.applyButton} ${localClasses.filterButton}`}
              startIcon={<FilterListIcon style={{ fontSize: 18 }} />}
              onClick={() => {
                setQueueTicket(queues);
                setDateStartTicket(dateStart);
                setDateEndTicket(dateEnd);
                setFetchDataFilter(!fetchDataFilter);
                fetchData(!fetchDataFilter);
              }}
            >
              {i18n.t("dashboard.filter")}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default Filters;
